/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterASmall = createReactComponent("letter-a-small", "IconLetterASmall", [
  ["path", { d: "M10 16v-6a2 2 0 1 1 4 0v6", key: "svg-0" }],
  ["path", { d: "M10 13h4", key: "svg-1" }]
]);

export { IconLetterASmall as default };
//# sourceMappingURL=IconLetterASmall.js.map
